export default __webpack_public_path__ + "static/media/park_linowy_uchwala_instrukcja.c6c40b99.pdf";